<div
    class="view-dates-card"
    *ngIf="data; else loadingSkeleton"
>
    <!-- Desktop View -->
    <ng-container *ngIf="!responsive.isSmallScreen">
        <div class="desktop-card-content">
            <!-- 1. Revenue (Top) -->
            <div class="revenue-text">
                <ng-container>
                    {{ ((data.totalRevenue || 0) / 100) | currency:undefined:undefined:'1.0-0' }}
                </ng-container>
            </div>

            <!-- 2. Event Counts (Centered) -->
            <div
                class="badges-container"
                *ngIf="data.totalEventsByType?.length"
            >
                <ng-container *ngFor="let type of data.totalEventsByType">
                    <div
                        *ngIf="type.count > 0"
                        class="event-count-item"
                        title="{{ type.count }} {{ type.type | titlecase }} Events"
                    >
                        <span
                            class="dot"
                            [style.background-color]="getEventTypeColor(type.type)"
                        ></span>
                        <span class="count">{{ type.count }}</span>
                    </div>
                </ng-container>
            </div>

            <!-- 5. Pacing -->
            <app-pacing-card
                *ngIf="showPacing"
                [pacing]="data.pacing"
                layout="card"
                [actualRevenue]="data.totalRevenue"
            ></app-pacing-card>

            <!-- 4. Forecast -->
            <app-forecast-card
                *ngIf="showForecast"
                [showForecast]="true"
                [showPacing]="false"
                [forecast]="data.prophet"
                layout="card"
                [date]="data.date"
                [actualJobs]="actualMovingJobs"
                [actualTrucksUsed]="data.actualTrucksUsed"
                [truckCapacity]="data.truckCapacity"
                [actualCrewUsed]="data.actualCrewUsed"
                [crewCapacity]="data.crewCapacity"
                [prophetMetrics]="prophetMetrics"
            ></app-forecast-card>

        </div>

        <!-- 3. Utilization/Capacity (Bottom) -->
        <div class="progress-section">
            <div class="progress-track truck-track">
                <div
                    class="progress-bar truck-bar"
                    [style.width.%]="truckUtilization"
                ></div>
                <span class="track-text">
                    <i class="pi pi-truck"></i> {{ data.actualTrucksUsed }}/{{ data.truckCapacity }}
                </span>
            </div>
            <div class="progress-track crew-track">
                <div
                    class="progress-bar crew-bar"
                    [style.width.%]="crewUtilization"
                ></div>
                <span class="track-text">
                    <i class="pi pi-users"></i> {{ crewRequired }}/{{ data.crewCapacity }}
                </span>
            </div>
        </div>
    </ng-container>

    <!-- Mobile View -->
    <ng-container *ngIf="responsive.isSmallScreen">
        <div class="mobile-card-content">
            <div class="revenue-top">
                <span *ngIf="data.totalRevenue > 0; else noRevenue">
                    {{ (data.totalRevenue / 100) | currency:undefined:undefined:'1.0-0' }}
                </span>
                <ng-template #noRevenue>&nbsp;</ng-template>
            </div>
            <div
                class="date-ring"
                [style.--utilization]="utilizationPercent + '%'"
                [style.--utilization-color]="getUtilizationColor()"
            >
                {{ data.date | date:'d' }}
            </div>
            <div class="mobile-stats">
                <span class="stat"><i class="pi pi-truck"></i> {{ data.actualTrucksUsed }}/{{ data.truckCapacity
                    }}</span>
                <span class="stat"><i class="pi pi-users"></i> {{ data.actualCrewUsed }}/{{ data.crewCapacity }}</span>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #loadingSkeleton>
    <div class="view-dates-card">
        <ng-container *ngIf="!responsive.isSmallScreen">
            <div class="revenue-text">
                <p-skeleton
                    width="5rem"
                    height="2rem"
                ></p-skeleton>
            </div>

            <div class="badges-container">
                <p-skeleton
                    width="1.5rem"
                    height="1.2rem"
                    borderRadius="4px"
                ></p-skeleton>
                <p-skeleton
                    width="1.5rem"
                    height="1.2rem"
                    borderRadius="4px"
                ></p-skeleton>
            </div>

            <div class="progress-container">
                <p-skeleton
                    width="100%"
                    height="8px"
                ></p-skeleton>
            </div>

            <div class="stats-container">
                <p-skeleton
                    width="100%"
                    height="1.2rem"
                ></p-skeleton>
                <p-skeleton
                    width="100%"
                    height="1.2rem"
                ></p-skeleton>
            </div>
        </ng-container>

        <ng-container *ngIf="responsive.isSmallScreen">
            <div class="mobile-card-content">
                <div class="revenue-top">
                    <p-skeleton
                        width="3rem"
                        height="1rem"
                    ></p-skeleton>
                </div>
                <div class="date-ring">
                    <p-skeleton
                        shape="circle"
                        size="2.2rem"
                    ></p-skeleton>
                </div>
                <div class="mobile-stats">
                    <p-skeleton
                        width="4rem"
                        height="0.8rem"
                        styleClass="mb-1"
                    ></p-skeleton>
                    <p-skeleton
                        width="4rem"
                        height="0.8rem"
                    ></p-skeleton>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>